import axiosInstance from '../api/axiosConfig';
import { obterIdEmpresa } from '../../utils/empresa';

export interface EmpresaStats {
  minhasVagas: number;
  vagasAtivas: number;
  candidaturasPendentes: number;
  candidatosAprovados: number;
  vagasFinalizadas: number;
}

export interface CandidaturasPorVaga {
  titulo: string;
  candidaturas: number;
  vagaId: number;
}

export const buscarEstatisticasEmpresa = async (): Promise<EmpresaStats> => {
  
  let minhasVagas = 0;
  let vagasAtivas = 0;
  let candidaturasPendentes = 0;
  let candidatosAprovados = 0;
  let vagasFinalizadas = 0;
  
  try {
    const empresaId = obterIdEmpresa();
    
    if (!empresaId) {
      console.error('❌ ID da empresa não encontrado no localStorage/sessionStorage - retornando zeros');
      return {
        minhasVagas: 0,
        vagasAtivas: 0,
        candidaturasPendentes: 0,
        candidatosAprovados: 0,
        vagasFinalizadas: 0
      };
    }


    // Buscar candidatos aprovados do banco de dados
    try {
      // Buscar candidatos aprovados que não estão contratados nem arquivados
      const aprovadosResponse = await axiosInstance.get(`/candidaturas/empresa/${empresaId}/aprovados`, {
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      
      const candidaturasAprovadas = Array.isArray(aprovadosResponse.data) 
        ? aprovadosResponse.data 
        : (aprovadosResponse.data?.data || aprovadosResponse.data?.content || []);
      
      // Contar apenas candidatos com status APROVADO e ativa='S'
      // O backend já retorna apenas os aprovados ativos (não arquivados e não contratados)
      candidatosAprovados = candidaturasAprovadas.length;
      
    } catch (error: any) {
      console.warn('Erro ao buscar candidatos aprovados:', error.message);
      candidatosAprovados = 0;
    }
    
    // Buscar vagas da empresa
    try {
      const vagasResponse = await axiosInstance.get(`/vagas/empresa/${empresaId}`, {
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      
      const vagas = Array.isArray(vagasResponse.data) 
        ? vagasResponse.data 
        : (vagasResponse.data?.data || vagasResponse.data?.content || []);
      
      minhasVagas = vagas.length;
      
      // Filtrar vagas ativas e finalizadas
      const vagasAtivasFiltradas = vagas.filter((vaga: any) => 
        vaga.ativo === true || vaga.ativo === 'true' || vaga.ativo === 1 || vaga.ativo === 'S'
      );
      
      const vagasFinalizadasFiltradas = vagas.filter((vaga: any) => 
        vaga.ativo === false || vaga.ativo === 'false' || vaga.ativo === 0 || vaga.ativo === 'N'
      );
      
      vagasAtivas = vagasAtivasFiltradas.length;
      vagasFinalizadas = vagasFinalizadasFiltradas.length;
      
      
    } catch (error: any) {
      console.warn('Erro ao buscar vagas:', error.message);
      minhasVagas = 0;
      vagasAtivas = 0;
      vagasFinalizadas = 0;
    }
    
    // Buscar candidaturas pendentes do banco de dados
    try {
      const pendentesResponse = await axiosInstance.get(`/candidaturas/empresa/${empresaId}/pendentes`, {
        timeout: 5000,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      });
      
      const candidaturasPendentesData = Array.isArray(pendentesResponse.data) 
        ? pendentesResponse.data 
        : (pendentesResponse.data?.data || pendentesResponse.data?.content || []);
      
      candidaturasPendentes = candidaturasPendentesData.length;
    } catch (error: any) {
      console.warn('Erro ao buscar candidaturas pendentes:', error.message);
      candidaturasPendentes = 0;
    }
    
  } catch (error) {
    console.error('Erro geral ao buscar estatísticas da empresa:', error);
  }
  
  const resultado = {
    minhasVagas,
    vagasAtivas,
    candidaturasPendentes,
    candidatosAprovados,
    vagasFinalizadas
  };

  
  return resultado;
};

export const buscarCandidaturasPorVaga = async (): Promise<CandidaturasPorVaga[]> => {
  
  try {
    const empresaId = localStorage.getItem('empresaId') || sessionStorage.getItem('empresaId');
    
    if (!empresaId) {
      console.error('ID da empresa não encontrado');
      return [];
    }

    const response = await axiosInstance.get(`/candidaturas/empresa/${empresaId}/por-vaga`, {
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });
    
    const data = Array.isArray(response.data) 
      ? response.data 
      : (response.data?.data || response.data?.content || []);
      
    return data;
  } catch (error: any) {
    console.warn('Erro ao buscar candidaturas por vaga:', error.message);
    return [];
  }
};

